import _ from 'lodash';

import {
  STATUS_APPEND,
  STATUS_REMOVE,
  REFRESH_SIDEBAR
} from './actions';

import createReducer from 'state/createReducer';

const initialState = {
  queue: {},
  url: ''
}

const handlers = {
  
  [STATUS_APPEND](state, payload) {

    const q = {...state.queue}

    const msg = _.get(payload, 'm', null);
    const type = _.get(payload, 't', 'error');

    let action = _.get(payload, 'a', null);
    if ( typeof action !== 'function' ) {
      action = null;
    }

    if ( msg !== null && msg.length > 0 ) {
      
      const id = uuidv4();
      q[id] = {
        i: id,
        t: type,
        m: msg,
        a: action
      }
    }

    return {
      ...state,
      queue: q
    }
  },

  [STATUS_REMOVE](state, payload) {

    if ( _.has(state.queue, payload) === true ) {
      let q = _.cloneDeep(state.queue);
      delete q[payload];

      return {
        ...state,
        queue: q
      }
    }

    return {
      ...state,
    }
  },

  [REFRESH_SIDEBAR](state, payload) {

      return {
        ...state,
        url: payload
      }
  }
}


function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


export default (state = initialState, action) => createReducer(state, action, handlers); 
